import type {InjectionKey} from 'vue';
import type {PrismicDocument} from '@prismicio/types';

const PRISMIC_DOCUMENT: InjectionKey<PrismicDocument | null> = Symbol('PRISMIC_NAVBAR_DOCUMENT');
const TRANSLATE_URL_FN: InjectionKey<(lang: string, country: string) => Promise<string>> = Symbol('TRANSLATE_URL_FN');

export const navbarUnloggedKeys = {PRISMIC_DOCUMENT, TRANSLATE_URL_FN};
